import { injectable } from "tsyringe";
import { KulionerApiRepository } from "@/app/infrastructures/repositories/api/KulionerApiRepository";
import { KulionerRepositoryInterface } from "@/data/persistences/repositories/contracts/KulionerRepositoryInterface";
import {
  KulionerListRequest,
  KulionerConfirmOrderRequest,
  KulionerUpdateMerchantOrderRequest
} from "@/data/payload/api/KulionerApiRequest";
import {
  DownloadReportRequest,
  KulionerCycle,
  KulionerMerchantEntites
} from "@/domain/entities/Kulioner";

@injectable()
export class KulionerPrensenter implements KulionerRepositoryInterface {
  private repository: KulionerApiRepository;

  constructor(repository: KulionerApiRepository) {
    this.repository = repository;
  }

  getList(params: KulionerListRequest) {
    return this.repository.getList(params);
  }

  get(id: number) {
    return this.repository.get(id);
  }

  updateToggle(id: number) {
    return this.repository.updateToggle(id);
  }

  updateKulioner(payload: KulionerConfirmOrderRequest) {
    return this.repository.updateKulioner(payload);
  }
  getDownloadReports(params: DownloadReportRequest) {
    return this.repository.getDownloadReports(params);
  }

  getListSummaryStatus(params: KulionerListRequest) {
    return this.repository.getListSummaryStatus(params);
  }

  getCycleList(): Promise<KulionerCycle[]> {
    return this.repository.getCycleList();
  }

  getListMerchant(
    params: KulionerListRequest
  ): Promise<KulionerMerchantEntites> {
    return this.repository.getListMerchant(params);
  }

  updateMerchantOrder(payload: KulionerUpdateMerchantOrderRequest) {
    return this.repository.updateMerchantOrder(payload);
  }
}
